import NotificationMixin from './NotificationMixin';
import UtilsMixin from './UtilsMixin';

export default {
  mixins: [NotificationMixin, UtilsMixin],
  data: () => ({
    finallyServiceRequest: false,
    configServiceSwal: {
      successMessage: 'Sucesso ao fazer a requisição!',
      errorMessage: 'Falha ao fazer a requisição',
      showSuccessSwal: true,
      showErrorSwal: true,
    },
  }),
  methods: {
    callService(request, ...props) {
      const { cb, config } = this.getServiceMixinProps(props);
      const {
        successMessage,
        errorMessage,
        showSuccessSwal,
        showErrorSwal,
      } = {
        ...this.configServiceSwal,
        ...config,
      };
      let successServiceData = {};
      let errorServiceResponse = null;
      request
        .then((response) => {
          if (showSuccessSwal) {
            this.showSuccessToast({
              text: (successMessage),
            });
          }
          successServiceData = { ...response };
        }).catch((err) => {
          errorServiceResponse = { ...err };
          if (showErrorSwal) {
            this.showMessageError(err, errorMessage);
          }
        })
        .finally(() => {
          if (cb) {
            cb(
              successServiceData,
              errorServiceResponse,
            );
          }
        });
    },
    getServiceMixinProps(rest = []) {
      let cb = null;
      let config = {};

      rest.forEach(
        (item) => {
          if (item) {
            if (typeof item === 'function') {
              cb = item;
            }
            if (typeof item === 'object') {
              config = item;
            }
          }
        },
      );
      return {
        cb,
        config,
      };
    },
    showMessageError(err, message) {
      this.showErrorToast(
        this.setMessageError(err, message),
      );
    },
    setMessageError(err, messageError) {
      let message;

      if (this.hasMessageError(err)) {
        message = err.response.data.message;
      } else {
        message = messageError;
      }

      return {
        text: message,
      };
    },
    hasData(response) {
      return this.isObj(response) && !this.isEmptyItem(response.data);
    },
    hasMessageError(err) {
      return err
        && err.response
        && err.response.data
        && err.response.data.message;
    },
    prepareData(data) {
      if (data) {
        if (data.content) {
          return data.content;
        }
        if (data.data) {
          return Array.isArray(data.data)
            ? data.data
            : [data];
        }
        return Array.isArray(data)
          ? data : [data];
      }
      return data;
    },
    makeParams(defaultParams = {}) {
      return {
        Page: 1,
        PerPage: 1000,
        ...defaultParams,
      };
    },
    overrideNullProperties(data, referencePayload = {}) {
      return this.setOverrideProps(data, referencePayload);
    },
  },
};
